import user from './user';
import activeConversation from './activeConversation';
import onlineWarning from './onlineWarning';
import modal from './modal';
import {persistCombineReducers} from "redux-persist";
import storage from 'redux-persist/es/storage';

const persistConfig = {
    key: 'user',
    storage,
    blacklist: ['modal'],
};

const callemanApp = persistCombineReducers(persistConfig, {user, activeConversation, onlineWarning, modal});

export default callemanApp;


// WEBPACK FOOTER //
// ./src/reducers/index.js